export enum PORTALTYPE {
    ADMIN = 'admin',
    COMPANY = 'company', 
};